import { Navigate, Route, Routes } from 'react-router';
import { ApiKeysList } from './routes/ApiKeysList';
import { AppShell } from './routes/AppShell';
import { Catalog } from './routes/Catalog';
import { EventCreate } from './routes/EventCreate';
import { EventSetup } from './routes/EventSetup';
import { EventsList } from './routes/EventsList';
import { Login } from './routes/Login';
import { MyAccount } from './routes/MyAccount';
import { NotFound } from './routes/NotFound';
import { RequireAuth } from './routes/RequireAuth';
import { RequireOwner } from './routes/RequireOwner';
import { Sales } from './routes/Sales';
import { SalesByCategory } from './routes/SalesByCategory';
import { SalesByProduct } from './routes/SalesByProduct';
import { SalesOverview } from './routes/SalesOverview';
import { SalesTimeline } from './routes/SalesTimeline';
import { SalesTransactions } from './routes/SalesTransactions';
import { StripeAccountCreate } from './routes/StripeAccountCreate';
import { StripeAccountEdit } from './routes/StripeAccountEdit';
import { StripeAccountsList } from './routes/StripeAccountsList';
import { UserCreate } from './routes/UserCreate';
import { UserEdit } from './routes/UserEdit';
import { UsersList } from './routes/UsersList';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<Navigate to="/events" replace />} />
          <Route path="/events" element={<EventsList />} />
          <Route element={<RequireOwner />}>
            <Route path="/events/new" element={<EventCreate />} />
          </Route>
          <Route path="/events/:eventId/setup" element={<EventSetup />} />
          <Route path="/events/:eventId/catalog" element={<Catalog />} />
          <Route path="/events/:eventId/sales" element={<Sales />}>
            <Route index element={<SalesOverview />} />
            <Route path="products" element={<SalesByProduct />} />
            <Route path="categories" element={<SalesByCategory />} />
            <Route path="timeline" element={<SalesTimeline />} />
            <Route path="transactions" element={<SalesTransactions />} />
          </Route>
          <Route path="/me" element={<MyAccount />} />
          {/* API keys: owner + manager may mint, so this sits under RequireAuth
              (not RequireOwner). A manager's key inherits their own event access. */}
          <Route path="/api-keys" element={<ApiKeysList />} />
          <Route element={<RequireOwner />}>
            <Route path="/users" element={<UsersList />} />
            <Route path="/users/new" element={<UserCreate />} />
            <Route path="/users/:userId/edit" element={<UserEdit />} />
            <Route path="/stripe-accounts" element={<StripeAccountsList />} />
            <Route path="/stripe-accounts/new" element={<StripeAccountCreate />} />
            <Route
              path="/stripe-accounts/:accountId/edit"
              element={<StripeAccountEdit />}
            />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
